<template>
  <dialog-base>
    <div class="mod-egg">
      <!-- <div class="box-map">
      </div> -->
      <div class="tip">
        {{tipMap[num]}}
      </div>
      <div class="btn-red">
        <span class="text"
              @click="close">继续寻宝</span>
      </div>
    </div>
  </dialog-base>
</template>

<script>
import DialogBase from '../base'
import mixin from '../mixin'
import {
  RuleText
} from '@/constants'
import { random } from '@actly/core'
export default {
  mixins: [mixin],
  components: {
    DialogBase
  },
  data() {
    return {
      tipMap: [
        '“从长远看，大约90%的投资收益都是来自成功的资产配置。——加里·布林森”',
        '时间投资价值就是“找到专业的公司，做时间的朋友”。',
        '人生就像滚雪球，最重要的是发现很湿的雪和很长的坡。——沃伦·巴菲特'
      ],
      num: random(0, 2),
      RuleText,
      isShowControl: true
    }
  },
  mounted() {
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.mod-egg {
  padding: 717px 70px 0px;
  width: 723px;
  height: 953px;
  background-image: url("~@/assets/dialog/dialog-map.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  .box-map {
    width: 582px;
    height: 423px;
    background-image: url("~@/assets/dialog/dialog-map.jpg");
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .tip {
    margin: 0 18px;
    text-align: center;
    font-size: 30px;
    color: #f57906;
  }
  .btn-red {
    margin: 20px auto 0;
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 479px;
    height: 95px;
    background-image: url("~@/assets/ico/btn-red.png");
    background-size: 100% auto;
    background-repeat: no-repeat;
    .text {
      font-size: 32px;
      font-weight: 700;
      color: #ffffff;
      text-shadow: #872c0c 2px 0 2px, #872c0c 0 2px 2px, #872c0c -2px 0 2px,
        #872c0c 0 -2px 2px;
    }
  }
}
</style>